import { connect } from 'react-redux'
import { Component } from "react"
import * as THREE from 'three';
import { IconDeviceFloppy, IconEye} from '@tabler/icons-react';
import {
  Button,
  LoadingOverlay,
  Popover,
  ScrollArea,
  Accordion,
  Drawer,
  TextInput,
  ActionIcon,
  Divider,
  CloseButton,
  Stack,
  Paper, Flex
} from "@mantine/core";


import{ onEditMode } from "../../actions" 
import { word3D } from '../../game/loader';



let mouse_mv_rebond = undefined
let mouse_up_rebond = undefined
let create_element_rebond = undefined
let editor_mode_rebond  = undefined
let load_rebond = undefined
const distBoxMouse = 5


const pathContext = {
    scene3D: null,
    zoom: 16,
    mode: "",
    version: 0,
    loading: false,
    /*objectsScene: {},*/
    somthing_to_do: 0,
    mouseBox: new THREE.Mesh(new THREE.SphereGeometry(distBoxMouse, 32, 16), new THREE.MeshPhongMaterial( {color: 0x00FFFF, transparent: true, opacity: 0.4} )),
    currentSelection: null,
    currentHighlight:null,
    accordion:{
        type: "",
        element_index: -1
    },
    toSave: false
}

class WordObjects extends Component{
  constructor(props) {
      super(props)
      this.state = pathContext

      if(props.objectsScene){ 
        //this.state.objectsScene = props.objectsScene
      }
  }

  makeStateCopy(){
    return {
        scene3D: this.state.scene3D,
        zoom: this.state.zoom,
        mode: this.state.mode,
        somthing_to_do: this.state.somthing_to_do,
        loading: this.state.loading,
        //objectsScene: this.state.objectsScene,
        mouseBox: this.state.mouseBox,
        currentSelection: this.state.currentSelection,
        currentHighlight: this.state.currentHighlight,
        accordion: this.state.accordion,
        version: this.state.version + 1,
        toSave: this.state.toSave,   
    }
    }

  async componentDidMount() {
    
    this.props.notification.addNotification("mousemove", (type, msg, arg)=>{
        if(!mouse_mv_rebond){
            mouse_mv_rebond = setInterval(()=>{
            clearInterval(mouse_mv_rebond)
            mouse_mv_rebond = undefined
            this.onMouseMove(msg)
            }, 5)
        }
    })

    this.props.notification.addNotification("zoom", (type, msg, arg)=>{
      if(msg.container !== "map-world") return
      this.state.zoom = msg.zoom
      this.setState(this.state)
      this.placeZoomAll()
    })

    this.props.notification.addNotification("mouseup", (type, msg, arg)=>{
        if(!mouse_up_rebond){
            mouse_up_rebond = setInterval(()=>{
            clearInterval(mouse_up_rebond)
            mouse_up_rebond = undefined
            this.onMouseUp(msg)
            }, 5)
        }
    })

    this.props.notification.addNotification("Scene3D", async (type, msg, arg)=>{
      if(msg.container !== "map-world") return
      if(!load_rebond){ 
        console.log("load_rebond")
        load_rebond = setInterval(async ()=>{
          
          let state = this.makeStateCopy()

            //if(msg.container !== this.state.id) return
          
          state.loading = true
          
          state.scene3D = arg

          state.scene3D.scene.add(state.mouseBox)
          state.mouseBox.rotateX(Math.PI/4)
          state.zoom =state.scene3D.map.getZoom()
          state.loading = false
          this.setState(state)
          setTimeout(async ()=>{
            await this.load();
          }, 10)
          clearInterval(load_rebond)
        }, 150)
      }
    })
    this.props.notification.addNotification("CreateElement3D", (type, msg, arg)=>{
      if(!create_element_rebond){
        create_element_rebond = setInterval(()=>{
          clearInterval(create_element_rebond)
          create_element_rebond = undefined
            this.onCreateObjet3D(msg.element, arg.lngLat)
          }, 5)
      }
    })

    this.props.notification.addNotification("EditorMode", (type, msg, arg)=>{
      if(!editor_mode_rebond){
        editor_mode_rebond = setInterval(()=>{
          clearInterval(editor_mode_rebond)
          editor_mode_rebond = undefined
          let state = this.makeStateCopy()
          state.mode = msg.value
          this.setState(state)
        }, 5)
      }
    })

    this.props.notification.addNotification("SaveIndicator", async (type, msg, arg)=>{
        let state = this.makeStateCopy()

        let nb = 0
        for(let k in this.props.objectsScene){
          for(let i=0; i < this.props.objectsScene[k].length; i ++){
            if(this.props.objectsScene[k][i].toSave){
              nb++
            }
          }
        }
        state.somthing_to_do = nb
        state.toSave = nb>0
        this.props.notification.onNotification("Indicator", {from: "WordObjects", value: state.somthing_to_do + ""}, {})
        this.setState(state)
    })
    
    let state = this.makeStateCopy()
    
    this.setState(state)

    this.props.notification.onNotification("Scene3DAsk")

  }

  async load() {
    let state = this.makeStateCopy()
    state.loading = true
    this.props.notification.onNotification("Loading",{loading: true})
    this.setState(state)


    state.loading = false
    this.props.notification.onNotification("Loading",{loading: false})
    this.setState(state)
  }

  placeZoomAll(zoom){
    for(let k in this.props.objectsScene){
      const types = this.props.objectsScene[k]
      for(let i=0; i < types.length; i ++){ 
        this.placeZoom(types[i].gltf, types[i].element3D.scale, zoom)
      }
    }
  }

  placeZoom(gltf, scale, z){
    if(!scale) return
    z = Math.floor(z)
    if(scale[z]){ 
      gltf.scene.scale.set(scale[z].x, scale[z].y, scale[z].z)
    }
    else{
        for(z; z < 20; z++){
          if(scale[z]){ 
            gltf.scene.scale.set(scale[z].x, scale[z].y, scale[z].z)
            break
          }
        }
    }
  }


  onCreateObjet3D(element3D, lngLat){
    
    const state = this.makeStateCopy()
    if(!state.scene3D  || !state.scene3D.map) return
    
    state.somthing_to_do += 1
    const {x: x, y:y, z:z} = state.scene3D.map.getPosition3D(lngLat)
    this.props.notification.onNotification("Indicator", {from: "WordObjects", value: state.somthing_to_do + ""}, {})
    this.setState(state)
    const elm = element3D.element3D

    if(elm && elm.parameters){
      if(elm.parameters.scale){
        this.placeZoom(element3D.gltf, elm.parameters.scale, this.state.zoom)
      }
      
      if(elm.parameters.rotate){
        element3D.gltf.scene.rotation.set(elm.parameters.rotate.x, elm.parameters.rotate.y, elm.parameters.rotate.z)
      }
      if(elm.parameters.y){
        element3D.gltf.scene.position.set(element3D.gltf.scene.position.x, elm.parameters.y, element3D.gltf.scene.position.z)
      }
    }

    state.scene3D.scene.add(element3D.gltf.scene)
    const t = element3D.element3D.type
    if(!this.props.objectsScene[t]){
      this.props.objectsScene[t] = []
    }

    this.props.objectsScene[t].push(element3D)
    element3D.lngLat = lngLat
    element3D.toSave = true
    state.toSave = true
    console.log("WordObjects.onCreateObjet3D", element3D, x, y, z)
    this.setState(state)
  }


  updateCoordinate(state, msg){
    if(!state.scene3D || !state.scene3D.map) return
    const {x: x, y:y, z:z} = state.scene3D.map.getPosition3D(msg.lngLat)
    if(state.mouseBox){ 
        state.mouseBox.position.set(x, y, z)
    }
  }

  getCollisionObject(lngLat){
    const state = this.makeStateCopy()
    if(!state.scene3D || !state.scene3D.map) return undefined
    
    let last = 1000000000
    let c = undefined 

    const {x: x, y:y, z:z} = state.scene3D.map.getPosition3D(lngLat)
    for(let k in this.props.objectsScene){ 
      const objectsScene = this.props.objectsScene[k]
      for(let i=0; i < objectsScene.length; i ++){
          const obj = objectsScene[i]
          if(!obj || !obj.gltf || !obj.gltf.boundings) continue

          let box
          let boxSize = -100
          obj.gltf.scene.traverse( function ( child ){
              if ( child.isMesh )
              {
              const b = new THREE.Box3().setFromObject(child);
              
              const s = b.getSize(new THREE.Vector3()).length();
              if(s > boxSize){
                  boxSize = s
                  box = b
              }
              
              }
          });
          if(box){ 
              const v = box.getCenter(new THREE.Vector3())
              //obj.gltf.scene.localToWorld(v);
              //const z = v.z 
              v.z = v.y;
              //v.x = z;
              v.y = 0;

              const s = 2*(box.getSize(new THREE.Vector3()).length()/2)/3;
              const p = new THREE.Vector3(state.mouseBox.position.x, state.mouseBox.position.y, state.mouseBox.position.z)
              const pp = new THREE.Vector3(obj.gltf.scene.position.x, obj.gltf.scene.position.y, obj.gltf.scene.position.z)
              const lx = (box.max.x - box.min.x)
              const lz = (box.max.z - box.min.z)
              let r = lx
              if(r > lz){
                r = lz
              }
              r /= 2
              const d = p.distanceTo(v)
              if(d <= s){
                if(d < last){ 
                  c = obj
                  last = d
                }
                
              }

              //console.log("getCollisionObject", obj.element3D.nom, s, lx, lz, p.distanceTo(v))
              
          }
      }
    }
    return c
  }


  onMouseMove(msg){
    const state = this.makeStateCopy()

    if(!state.scene3D || !state.scene3D.map) return

}
  
  onMouseUp(msg){
    const state = this.makeStateCopy()
    if(state.currentHighlight )
    {
      state.currentHighlight.obj.gltf.scene.remove(state.currentHighlight.cube)
    }
    if(state.currentSelection )
      {
        state.currentSelection.obj.gltf.scene.remove(state.currentSelection.cube)
      }
    const o = this.getCollisionObject(msg.lngLat)
    if(o){

      state.currentSelection = {}
            //const object = new THREE.Mesh( cube.geometry, new THREE.MeshBasicMaterial( {color: 0x00ff00} ) );
      
      
      state.currentSelection.obj = o
      
      const dx = o.gltf.boundings.boundingRect.max.x - o.gltf.boundings.boundingRect.min.x
      const dy = o.gltf.boundings.boundingRect.max.y - o.gltf.boundings.boundingRect.min.y
      const dz = o.gltf.boundings.boundingRect.max.z - o.gltf.boundings.boundingRect.min.z

      const center = o.gltf.boundings.boundingRect.getCenter(new THREE.Vector3())
      const gltf = state.currentSelection.obj.gltf
      const geometry = new THREE.BoxGeometry( dx, dy, dz );
      const edgesGeometry = new THREE.EdgesGeometry( geometry );
      const material = new THREE.LineBasicMaterial({color: 0x00ff00});

      const edges = new THREE.LineSegments( edgesGeometry, material );

      state.currentSelection.cube = edges
      edges.position.set(center.x, center.y, center.z)
      //edges.scale.set(gltf.scene.scale.x, gltf.scene.scale.y, gltf.scene.scale.z)
      //cube.update();
      
      gltf.scene.add(edges)

    }

    this.setState(state)
  }

  async save(){
    const state = this.makeStateCopy()
    const uri = "/add/3d/word"
    for(let k in this.props.objectsScene){
      const objects = this.props.objectsScene[k]
      for(let i=0; i < objects.length; i ++){
        const elm = objects[i]

        if(!elm.toSave) continue;

        const data = {
          mesh3D_id: elm.element3D.id,
          lngLat: elm.lngLat
        }

        if(elm.uid){
          data.uid = elm.uid
        }
        if(elm.parameters){
          data.parameters = elm.parameters
        }
        
        try{
          const response = await fetch(uri, {
            method: "PUT",
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)})
          
          if(response.status  === 200){ 
            const ret = await response.json();
            console.log(ret)
            if(ret && ret.uid){
              elm.uid = ret.uid
            }
            state.toSave = false
          }
        }
        catch(e){

        }
        
      }
    }

    this.setState(state)
  }

  render() {
      if (this.state.mode !== "object"){
        return (
          <>
            
          </>
        )
      }
      return (
        <>
          
          <Accordion className='accordion' value={this.state.accordion.type} onChange={(value)=>{
                                              const state = this.makeStateCopy()
                                              state.accordion.type = value
                                              this.setState(state)
                                          }}>
            <ScrollArea>
              {
                Object.keys(this.props.objectsScene).map( (type, index) => (
                  <>
                    <Accordion.Item key={index} value={type}>
                      <Accordion.Control>
                          <h2 >{type}</h2>
                      </Accordion.Control>
                      <Accordion.Panel>
                        <Accordion value={this.state.accordion.element_index} onChange={(value)=>{
                                                                                                const state = this.makeStateCopy()
                                                                                                state.accordion.element_index = value
                                                                                                this.setState(state)}}>
                        {
                          this.props.objectsScene[type].map((element3D, position)=>(
                            <>
                              <Accordion.Item key={position} value={`${type}-${position}`}>
                                <Accordion.Control>{element3D.element3D.nom}</Accordion.Control>
                                <Accordion.Panel>
                                  <ActionIcon variant="filled" aria-label="Settings" onClick={()=>{
                                      this.props.notification.onNotification("NavigateLngLat", element3D.lngLat)
                                  }}><IconEye size={14}/></ActionIcon>
                                </Accordion.Panel>
                              </Accordion.Item>
                            </>
                          ))
                        }

                        </Accordion>

                      </Accordion.Panel>
                    </Accordion.Item>
                  </>
                ))
              }
            </ScrollArea>
          </Accordion>
          {
              this.state.toSave === true?(<Button style={{ "width": "60%", "marginTop": "1rem"}} rightSection={<IconDeviceFloppy size={14} />} onClick={async ()=>{await this.save()}}>Sauvegarde</Button>):""
          }
        </>
        )
  }

}

const mapDispatchToProps = {
  onEditMode: onEditMode
}

const mapStateToProps = (state) => {  
    return {
        editMode: state.editMode,
        notification: state.notification
    }
}


WordObjects = connect(mapStateToProps, mapDispatchToProps)(WordObjects);

export default WordObjects;
